import { FormEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Button,
  ChevronRightIcon,
  Input,
  showToast,
  Text,
} from '@mercai/clever'
import { Comment } from './components'

import { CommentsProps } from './comments.type'

import styles from './comments.module.css'

export const Comments = <T,>({
  comments,
  isLoading,
  createComment,
  deleteComment,
  updateComment,
  invalidateQueries,
  hasPermissionToEditOrDelete,
}: CommentsProps<T>) => {
  const { t } = useTranslation('componentsComments')

  const [comment, setComment] = useState('')

  const isLoadingAll = isLoading

  const onHandleSetComment = (value: string) => {
    if (value.length > 255) {
      return setComment(value.slice(0, 255))
    }
    setComment(value)
  }

  const handleSendComment = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!comment) {
      return
    }

    const response = await createComment({
      comment,
    })

    if (response.success) {
      setComment('')

      invalidateQueries?.()

      return
    }

    showToast({
      variant: 'error',
      title: response?.message || t('commentsErrorMessageDescription'),
    })
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <Text variant="title-medium">
            {t('commentsTitle', {
              value: comments?.length || 0,
            })}
          </Text>
        </div>
        <div className={styles.comments}>
          {!isLoadingAll &&
            comments?.map((item, index) => {
              return (
                <Comment
                  key={index}
                  comment={item}
                  hasPermissionToEditOrDelete={hasPermissionToEditOrDelete(
                    item,
                  )}
                  updateComment={updateComment}
                  deleteComment={deleteComment}
                  invalidateQueries={invalidateQueries}
                />
              )
            })}
          {!isLoadingAll && (!comments || comments?.length === 0) && (
            <Text>{t('commentsEmptyLabel')}</Text>
          )}
        </div>
        <form
          className={styles['send-comment']}
          onSubmit={(e) => handleSendComment(e)}
        >
          <Input
            className={styles.input}
            placeholder={t('commentsInputPlaceholder')}
            value={comment}
            onChange={(value) => onHandleSetComment(value)}
          />
          <Button
            type="submit"
            className={styles.button}
            isActive={!isLoading}
            disabled={isLoading}
          >
            <ChevronRightIcon />
          </Button>
        </form>
      </div>
    </>
  )
}
